import React, { Component } from 'react';
import classnames from 'classnames';
import debounce from 'lodash/debounce';

import propTypes, { defaultProps } from './props';

export const buildBlankPageUrl =
  (urlBase, { version, themeId, themeAssemblyVersion } = {}) =>
    `${urlBase}?ver=${version || ''}${themeId || ''}${themeAssemblyVersion || ''}`;

export default class WaHtmlEditor extends Component
{
  static propTypes = propTypes;

  static defaultProps = defaultProps;

  constructor(props)
  {
    super(props);

    const { editorConfig: { editorId }, dataChangedTimeout } = props;

    this.idIn = `${editorId}-In`;
    this.idOut = `${editorId}-Out`;
    this.timeout = null;
    this.onEditorDataChanged = debounce(this.onEditorDataChanged.bind(this), dataChangedTimeout);
  }

  componentDidMount()
  {
    this.createWaEditor(this.props.editorRoot);
  }

  shouldComponentUpdate()
  {
    return false;
  }

  componentWillUnmount()
  {
    if (!this.editor) { return; }

    clearTimeout(this.timeout);

    this.editor.EditorDataChanged.removeHandler(this.onEditorDataChanged);
    this.editor.EditorBlur.removeHandler(this.onEditorBlur);
    this.props.onBlur(this.getHtmlContent());

    this.onEditorDataChanged.cancel();
    this.editor.unload();
    this.editor = null;
  }

  getHtmlContent()
  {
    return this.editor.getData().htmlContent;
  }

  onEditorDataChanged()
  {
    this.props.onDataChanged(
      this.getHtmlContent()
    );
  }

  onEditorBlur = () =>
  {
    if (this.editor)
    {
      if (this.timeout)
      {
        clearTimeout(this.timeout);
      }

      this.timeout = setTimeout(() =>
      {
        if (this.editor)
        {
          this.props.onBlur(
            this.getHtmlContent()
          );
        }
      }, 10);
    }
  };

  createWaEditor = (Editor) =>
  {
    const {
      editorConfig,
      env,
      toolbar,
      macros
    } = this.props;

    const {
      editorId,
      blankPageURL,
      displayMode,
      toolbarConfigKey,
      autoStart,
      autoFocus,
      minEditorHeight,
      mainIdForBodyStyles,
      mainClassForBodyStyles,
      extParameters
    } = editorConfig;

    this.editor = Editor.EditorsManager.createEditor(
      editorId,
      this.idIn,
      this.idOut,
      buildBlankPageUrl(blankPageURL, env),
      displayMode,
      toolbar,
      Editor.environment.topWindow[toolbarConfigKey],
      autoStart,
      autoFocus,
      minEditorHeight,
      mainIdForBodyStyles,
      mainClassForBodyStyles,
      {
        isTidyServiceOn: Editor.AdminPanel.Resources.AdminEditor.isTidyServiceOn,
        ...extParameters,
        macros,
        isReactComponentEditor: true
      }
    );

    this.editor.initEditor(displayMode);
    this.editor.EditorDataChanged.addHandler(this.onEditorDataChanged);
    this.editor.EditorBlur.addHandler(this.onEditorBlur);
  };

  render()
  {
    const {
      className,
      targetWidth,
      style: propsStyle,
      editorConfig: { minEditorHeight },
      content
    } = this.props;

    const classNames = classnames('-wa-html-editor', className);
    const widthStyle = targetWidth ? { width: targetWidth } : {};
    const minHeightStyle = minEditorHeight ? { minHeight: `${minEditorHeight}px` } : {};
    const style = { ...propsStyle, ...widthStyle };
    const inContainerStyle = { ...widthStyle, ...minHeightStyle };

    // eslint-disable-next-line
    const input = (<div style={inContainerStyle} id={this.idIn} dangerouslySetInnerHTML={{ __html: content }} />);

    return (
      <div className={classNames} style={style}>
        {input}
        <input type="hidden" id={this.idOut} />
      </div>
    );
  }
}